import { Routes, Route } from "react-router-dom";

import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/verify-otp" element={<Pages.Verification />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/users" element={<Pages.Individuals />} />
      <Route path="/bookings" element={<Pages.Bookings />} />
      <Route path="/bookings/details/:id" element={<Pages.BookingDetails />} />
      <Route path="/categories" element={<Pages.Categories />} />
      <Route
        path="/subscriptions/manage-subscriptions"
        element={<Pages.Subscription />}
      />
      <Route
        path="/subscriptions/manage-subscriptions/add"
        element={<Pages.AddSubscription />}
      />
      <Route
        path="/subscriptions/manage-subscriptions/edit/:id"
        element={<Pages.AddSubscription />}
      />
      <Route
        path="/subscriptions/manage-active-subscriptions"
        element={<Pages.ActiveSubscriptions />}
      />
      <Route
        path="/manage-investments/reporting-dashboard"
        element={<Pages.Investment />}
      />
      <Route
        path="/manage-investments/investor-applications"
        element={<Pages.InvestorApplications />}
      />
      <Route
        path="/manage-investments/agreement-management"
        element={<Pages.ManageAgreement />}
      />
      <Route
        path="/manage-investments/investment-plans"
        element={<Pages.InvestmentPlans />}
      />
      <Route
        path="/manage-investments/investment-plans/edit/:id"
        element={<Pages.AddInvestmentPlan />}
      />
      <Route
        path="/manage-investments/investment-plans/add"
        element={<Pages.AddInvestmentPlan />}
      />
      <Route
        path="/manage-investments/roi-management"
        element={<Pages.RoiDisbursement />}
      />
      <Route path="/users/detail/:id" element={<Pages.ProfileDetail />} />
      <Route path="/user/edit/:id" element={<Pages.EditProfile />} />
      <Route path="/permission-denied" element={<Pages.PermissionDenied />} />

      <Route
        path="/manage-CustomerSupport"
        element={<Pages.ManageCustomerSupport />}
      />
      <Route
        path="/listings/individual"
        element={<Pages.IndividualListings />}
      />
      <Route path="/listings/myList" element={<Pages.MyListings />} />
      <Route path="/listings/add" element={<Pages.AddVehicle />} />
      <Route path="/listings/edit/:id" element={<Pages.AddVehicle />} />
      {/* ------------------ */}

      {/* Regional Spec */}
      <Route
        path="/vehicle-specifications/regional-specifications"
        element={<Pages.RegionalSpec />}
      />
      <Route
        path="/vehicle-specifications/regional-specifications/add"
        element={<Pages.AddRegionalSpec />}
      />
      <Route
        path="/vehicle-specifications/regional-specifications/edit/:id"
        element={<Pages.AddRegionalSpec />}
      />

      <Route path="/manage-payment" element={<Pages.Payment />} />
      <Route path="/manage-analytics" element={<Pages.Analytics />} />

      <Route
        path="/ratings-and-reviews"
        element={<Pages.RatingsAndReviews />}
      />
      <Route path="/listing-detail/:id" element={<Pages.VehicleDetail />} />

      <Route
        path="/dashboard/downloaded-users"
        element={<Pages.DownloadedUsers />}
      />

      <Route
        path="/dashboard/registered-users"
        element={<Pages.RegisteredUsers />}
      />

      <Route path="/report-an-issue" element={<Pages.ReportAnIssue />} />

      <Route path="/reports" element={<Pages.Reports />} />
      <Route path="/user-management/roles" element={<Pages.Roles />} />
      <Route path="/user-management/user-list" element={<Pages.UserList />} />
      <Route path="/broadcast-message" element={<Pages.BroadcastMessage />} />
      <Route
        path="/profile-detail/:type/:id"
        element={<Pages.ProfileDetail />}
      />
      <Route
        path="/edit-profile-detail/:type/:id"
        element={<Pages.EditProfile />}
      />
      <Route path="/my-profile" element={<Pages.MyProfile />} />
      <Route
        path="/manage-notifications"
        element={<Pages.ManageNotifications />}
      />
      <Route
        path="/recieved-notifications"
        element={<Pages.RecievedNotifications />}
      />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />

      <Route path="/add-category" element={<Pages.AddCategory />} />
      <Route path="/edit-category/:id" element={<Pages.AddCategory />} />
      <Route path="/manage-partners" element={<Pages.ManagePartners />} />
      <Route
        path="/manage-partners/details/:id"
        element={<Pages.PartnerDetails />}
      />
      <Route path="/manage-discount" element={<Pages.ManageDiscount />} />
      <Route path="/manage-discount/add" element={<Pages.AddDiscount />} />
      <Route path="/manage-discount/edit/:id" element={<Pages.AddDiscount />} />
    </Routes>
  );
};

export default Routing;
